/* eslint-disable */
import Deferred from 'es6-deferred'
import { desktopBreakpoint } from '../../../../../constants'
import d3 from './d3-3'

export function SymmetrySetup() {
  // this.svg;
  // this.width;
  // this.height;

  this.create = function(data, settings) {
    this.divId = settings.el
    this.margin = settings.margin
    this.data = data
    var parent = d3.select('#' + this.divId)

    // Add class to parent div so that css selectors can be scoped
    parent.classed('symmetry-chart', true)

    var bbox = parent.node().getBoundingClientRect()
    this.width = bbox.width - this.margin.left - this.margin.right
    this.height = bbox.height - this.margin.top - this.margin.bottom

    this.rowHeight = this.height / data.length

    this.x = d3.scale.linear().range([0, this.width])
    this.x.domain([-0.25, 0.25])

    this.y = d3.scale.linear().range([this.height, 0])
    this.y.domain([-0.25, 0.25])

    var xAxis = d3.svg
      .axis()
      .scale(this.x)
      .orient('bottom')
      .tickSize(0)
      .tickPadding(20)

    var yAxis = d3.svg
      .axis()
      .scale(this.y)
      .orient('left')
      .tickSize(0)
      .tickPadding(20)

    this.svg = parent
      .append('svg')
      .attr('overflow', 'visible')
      .attr('width', this.width + this.margin.left + this.margin.right)
      .attr('height', this.height + this.margin.top + this.margin.bottom)
      .append('g')
      .attr(
        'transform',
        'translate(' + this.margin.left + ',' + this.margin.top + ')'
      )

    this.graph = this.svg.append('g').attr('id', 'graph')

    for (var i = 0; i < data.length; i++) {
      var datum = data[i]

      const yPos =
        window.innerWidth >= desktopBreakpoint
          ? i * this.rowHeight + this.rowHeight * 0.6
          : i * this.rowHeight + this.rowHeight * 1.2

      const xPos = window.innerWidth >= desktopBreakpoint ? -40 : -130
      const fontSize = window.innerWidth >= desktopBreakpoint ? '16px' : '14px'

      //Row label
      this.svg
        .append('text')
        .attr('id', 'label_' + i)
        .attr('class', 'descriptor')
        .text(datum.display_name)
        .attr('y', yPos)
        .attr('x', xPos)
        .attr('fill', '#000')
        .attr('text-anchor', 'end')
        .attr('font-family', 'GT-America-Thin')
        .attr('font-size', fontSize)

      this.graph
        .append('line')
        .attr('x1', 0)
        .attr('y1', i * this.rowHeight)
        .attr('x2', this.width)
        .attr('y2', i * this.rowHeight)
        .attr('stroke', '#959595')
        .attr('stroke-width', 1)

      //Patient Indicator
      var svgDefs = this.graph.append('defs')
      var filter = this.graph.append('defs')
      // .append("filter")
      //   .attr("id", "blur")
      // .append("feGaussianBlur")
      //   .attr("stdDeviation", 5);
      var gradient = svgDefs
        .append('linearGradient')
        .attr('id', 'gradientDef')
        .attr('gradientUnits', 'objectBoundingBox')

      // Create the stops of the main gradient.
      // Colors are set by class in the CSS file
      gradient
        .append('stop')
        .attr('class', 'high')
        .attr('offset', '0')

      gradient
        .append('stop')
        .attr('class', 'borderline-high')
        .attr('offset', '0.167')

      gradient
        .append('stop')
        .attr('class', 'intermediate')
        .attr('offset', '0.33')

      gradient
        .append('stop')
        .attr('class', 'normal')
        .attr('offset', '0.5')

      gradient
        .append('stop')
        .attr('class', 'intermediate')
        .attr('offset', '0.667')

      gradient
        .append('stop')
        .attr('class', 'borderline-high')
        .attr('offset', '0.83')

      gradient
        .append('stop')
        .attr('class', 'high')
        .attr('offset', '1')

      let rectWidth = this.width / 64

      // Rect indicator
      this.graph
        .append('clipPath')
        .attr('id', this.divId + '_indicator_clip_' + i)
        .append('rect')
        .attr('id', this.divId + '_indicator_' + i)
        .attr('x', this.width / 2)
        .attr('rx', 3)
        .attr('ry', 3)
        .attr('y', i * this.rowHeight) // -1: account for rounded corners
        .attr('width', rectWidth) //TODO: make relative to chart size
        .attr('height', this.rowHeight) // .attr("height", this.height - 0.5);

      // Gradient rect
      this.graph
        .append('rect')
        .attr('id', 'gradient-rect')
        .attr('class', 'gradient-background')
        .attr('x', 0)
        .attr('width', this.width)
        .attr('height', this.rowHeight)
        .attr('y', i * this.rowHeight)
        .attr('clip-path', 'url(#' + this.divId + '_indicator_clip_' + i + ')')
    }
    // Add lines and labels at start, middle and end
    // Start
    const fontSize = window.innerWidth >= desktopBreakpoint ? '16px' : '14px'

    this.graph
      .append('line')
      .attr('x1', 0)
      .attr('y1', 0)
      .attr('x2', 0)
      .attr('y2', this.height)
      .attr('stroke', '#959595')
      .attr('stroke-width', 1)

    //Todo: add class and style in CSS (many props in common for all three labels)
    this.svg
      .append('text')
      .attr('id', 'label_' + i)
      .text('-0.25')
      .attr('x', 0 + 18)
      .attr('y', -16)
      .attr('fill', '#000')
      .attr('text-anchor', 'middle')
      .attr('font-family', 'GT-America-Mono')
      .attr('font-size', fontSize)

    this.svg
      .append('text')
      .attr('id', 'label_' + i)
      .text('Left')
      .attr('x', 0)
      .attr('y', -40)
      .attr('fill', '#8D919F')
      .attr('text-anchor', 'start')
      .attr('font-family', 'GT-America-Thin')
      .attr('font-size', fontSize)

    // Middle
    this.graph
      .append('line')
      .attr('x1', this.width / 2)
      .attr('y1', 0)
      .attr('x2', this.width / 2)
      .attr('y2', this.height)
      .attr('stroke', '#959595')
      .attr('stroke-width', 1)

    this.svg
      .append('text')
      .text('0')
      .attr('x', this.width / 2)
      .attr('y', -16)
      .attr('fill', '#000')
      .attr('text-anchor', 'middle')
      .attr('font-family', 'GT-America-Mono')
      .attr('font-size', fontSize)

    // End
    this.graph
      .append('line')
      .attr('x1', this.width)
      .attr('y1', 0)
      .attr('x2', this.width)
      .attr('y2', this.height)
      .attr('stroke', '#959595')
      .attr('stroke-width', 1)

    this.svg
      .append('text')
      .text('+0.25')
      .attr('x', this.width - 18)
      .attr('y', -16)
      .attr('fill', '#000')
      .attr('text-anchor', 'middle')
      .attr('font-family', 'GT-America-Mono')
      .attr('font-size', fontSize)

    this.svg
      .append('text')
      .attr('id', 'label_' + i)
      .text('Right')
      .attr('x', this.width)
      .attr('y', -40)
      .attr('fill', '#808FA9')
      .attr('text-anchor', 'end')
      .attr('font-family', 'GT-America-Thin')
      .attr('font-size', fontSize)

    this.graph
      .append('line')
      .attr('x1', 0)
      .attr('y1', this.height)
      .attr('x2', this.width)
      .attr('y2', this.height)
      .attr('stroke', '#959595')
      .attr('stroke-width', 1)

    var deferred = new Deferred()
    deferred.resolve('resolved')
    return deferred
  }

  this.update = function(data) {
    for (var i = 0; i < data.length; i++) {
      var datum = data[i]

      const w =
        this.width / 2 === this.x(datum.value)
          ? this.width / 60
          : this.width / 64
      const x = this.x(datum.value)
      const compensated = x - w / 2

      this.graph
        .select('#' + this.divId + '_indicator_' + i)
        .transition(1000)
        .attr('x', compensated)
        .attr('width', w)
    }
  }

  this.randomValues = function() {
    for (var i = 0; i < this.data.length; i++) {
      var datum = this.data[i]
      datum.value = Math.random() * 0.5 - 0.25
    }
    this.update(this.data)
  }

  // this.create(data);
}
